"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),r=require("../styles.js");const o=e.css`
    ${r=>{return o=null==r?void 0:r.theme,e.css`
        --feature-icon-color-base: var(
            --feature-icon-color,
            var(
                --component-accent-color-base,
                ${null===(a=null===(t=null==o?void 0:o.colors)||void 0===t?void 0:t.primary)||void 0===a?void 0:a.default}
            )
        );
    `;var o,t,a}}
    ${r.addChildVerticalSpace()}
    .details-pane-secondary--feature {
        color: #0c1e34;
        display: flex;
        align-items: center;
        gap: 20px;
        line-height: 1.4;
    }
    .details-pane-secondary--feature-icon {
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        padding: 6px;
        color: var(--feature-icon-color-base);
    }
`;exports.default=o,exports.styles=o;
//# sourceMappingURL=styles.js.map
